import React from 'react';
import { Stack } from 'react-bootstrap';
import ParticipationHeader from '../../components/participation/participation-header';
import ParticipationContent from '../../components/participation/participation-content';

function AssessmentParticipation() {
  return (
    <Stack gap={1} className="h-100">
      <ParticipationHeader />
      <ParticipationContent />
    </Stack>
  );
}

export default AssessmentParticipation;
